import React from "react";
import loader from "../img/loader.gif";
const LoadingSpinner = () => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        padding: 10,
      }}
    >
      <img
        src={loader}
        alt="loaderSpinner"
        height="25px"
        width="25px"
        loading="lazy"
      />
    </div>
  );
};

export default LoadingSpinner;
